import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
import answers from './answers'
/**
* @see \App\Actions\Cases\GetAllCases::__invoke
* @see app/Actions/Cases/GetAllCases.php:17
* @route '/cases'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/cases',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Cases\GetAllCases::__invoke
* @see app/Actions/Cases/GetAllCases.php:17
* @route '/cases'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Cases\GetAllCases::__invoke
* @see app/Actions/Cases/GetAllCases.php:17
* @route '/cases'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Cases\GetAllCases::__invoke
* @see app/Actions/Cases/GetAllCases.php:17
* @route '/cases'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Cases\GetCase::__invoke
* @see app/Actions/Cases/GetCase.php:17
* @route '/cases/{year}/{month}/{day}/{sqid}'
*/
export const show = (args: { year: string | number, month: string | number, day: string | number, sqid: string | number } | [year: string | number, month: string | number, day: string | number, sqid: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/cases/{year}/{month}/{day}/{sqid}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Cases\GetCase::__invoke
* @see app/Actions/Cases/GetCase.php:17
* @route '/cases/{year}/{month}/{day}/{sqid}'
*/
show.url = (args: { year: string | number, month: string | number, day: string | number, sqid: string | number } | [year: string | number, month: string | number, day: string | number, sqid: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            year: args[0],
            month: args[1],
            day: args[2],
            sqid: args[3],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        year: args.year,
        month: args.month,
        day: args.day,
        sqid: args.sqid,
    }

    return show.definition.url
            .replace('{year}', parsedArgs.year.toString())
            .replace('{month}', parsedArgs.month.toString())
            .replace('{day}', parsedArgs.day.toString())
            .replace('{sqid}', parsedArgs.sqid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Cases\GetCase::__invoke
* @see app/Actions/Cases/GetCase.php:17
* @route '/cases/{year}/{month}/{day}/{sqid}'
*/
show.get = (args: { year: string | number, month: string | number, day: string | number, sqid: string | number } | [year: string | number, month: string | number, day: string | number, sqid: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Actions\Cases\GetCase::__invoke
* @see app/Actions/Cases/GetCase.php:17
* @route '/cases/{year}/{month}/{day}/{sqid}'
*/
show.head = (args: { year: string | number, month: string | number, day: string | number, sqid: string | number } | [year: string | number, month: string | number, day: string | number, sqid: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Actions\Cases\GetOgImage::__invoke
* @see app/Actions/Cases/GetOgImage.php:17
* @route '/cases/{year}/{month}/{day}/{sqid}/og-image.png'
*/
export const ogImage = (args: { year: string | number, month: string | number, day: string | number, sqid: string | number } | [year: string | number, month: string | number, day: string | number, sqid: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ogImage.url(args, options),
    method: 'get',
})

ogImage.definition = {
    methods: ["get","head"],
    url: '/cases/{year}/{month}/{day}/{sqid}/og-image.png',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Cases\GetOgImage::__invoke
* @see app/Actions/Cases/GetOgImage.php:17
* @route '/cases/{year}/{month}/{day}/{sqid}/og-image.png'
*/
ogImage.url = (args: { year: string | number, month: string | number, day: string | number, sqid: string | number } | [year: string | number, month: string | number, day: string | number, sqid: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            year: args[0],
            month: args[1],
            day: args[2],
            sqid: args[3],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        year: args.year,
        month: args.month,
        day: args.day,
        sqid: args.sqid,
    }

    return ogImage.definition.url
            .replace('{year}', parsedArgs.year.toString())
            .replace('{month}', parsedArgs.month.toString())
            .replace('{day}', parsedArgs.day.toString())
            .replace('{sqid}', parsedArgs.sqid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Cases\GetOgImage::__invoke
* @see app/Actions/Cases/GetOgImage.php:17
* @route '/cases/{year}/{month}/{day}/{sqid}/og-image.png'
*/
ogImage.get = (args: { year: string | number, month: string | number, day: string | number, sqid: string | number } | [year: string | number, month: string | number, day: string | number, sqid: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ogImage.url(args, options),
    method: 'get',
})

/**
* @see \App\Actions\Cases\GetOgImage::__invoke
* @see app/Actions/Cases/GetOgImage.php:17
* @route '/cases/{year}/{month}/{day}/{sqid}/og-image.png'
*/
ogImage.head = (args: { year: string | number, month: string | number, day: string | number, sqid: string | number } | [year: string | number, month: string | number, day: string | number, sqid: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ogImage.url(args, options),
    method: 'head',
})

/**
* @see \App\Actions\Cases\GetMyCases::__invoke
* @see app/Actions/Cases/GetMyCases.php:17
* @route '/my-cases'
*/
export const mine = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: mine.url(options),
    method: 'get',
})

mine.definition = {
    methods: ["get","head"],
    url: '/my-cases',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Cases\GetMyCases::__invoke
* @see app/Actions/Cases/GetMyCases.php:17
* @route '/my-cases'
*/
mine.url = (options?: RouteQueryOptions) => {
    return mine.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Cases\GetMyCases::__invoke
* @see app/Actions/Cases/GetMyCases.php:17
* @route '/my-cases'
*/
mine.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: mine.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Cases\GetMyCases::__invoke
* @see app/Actions/Cases/GetMyCases.php:17
* @route '/my-cases'
*/
mine.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: mine.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Cases\GetCaseEditor::__invoke
* @see app/Actions/Cases/GetCaseEditor.php:17
* @route '/cases/new'
*/
export const newMethod = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: newMethod.url(options),
    method: 'get',
})

newMethod.definition = {
    methods: ["get","head"],
    url: '/cases/new',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Cases\GetCaseEditor::__invoke
* @see app/Actions/Cases/GetCaseEditor.php:17
* @route '/cases/new'
*/
newMethod.url = (options?: RouteQueryOptions) => {
    return newMethod.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Cases\GetCaseEditor::__invoke
* @see app/Actions/Cases/GetCaseEditor.php:17
* @route '/cases/new'
*/
newMethod.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: newMethod.url(options),
    method: 'get',
})

/**
* @see \App\Actions\Cases\GetCaseEditor::__invoke
* @see app/Actions/Cases/GetCaseEditor.php:17
* @route '/cases/new'
*/
newMethod.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: newMethod.url(options),
    method: 'head',
})

/**
* @see \App\Actions\Cases\GetCaseEditor::__invoke
* @see app/Actions/Cases/GetCaseEditor.php:17
* @route '/cases/{case}/edit'
*/
export const edit = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/cases/{case}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Actions\Cases\GetCaseEditor::__invoke
* @see app/Actions/Cases/GetCaseEditor.php:17
* @route '/cases/{case}/edit'
*/
edit.url = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { case: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: typeof args.case === 'object'
        ? args.case.id
        : args.case,
    }

    return edit.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Cases\GetCaseEditor::__invoke
* @see app/Actions/Cases/GetCaseEditor.php:17
* @route '/cases/{case}/edit'
*/
edit.get = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Actions\Cases\GetCaseEditor::__invoke
* @see app/Actions/Cases/GetCaseEditor.php:17
* @route '/cases/{case}/edit'
*/
edit.head = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Actions\Cases\CreateCase::__invoke
* @see app/Actions/Cases/CreateCase.php:17
* @route '/cases'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/cases',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Actions\Cases\CreateCase::__invoke
* @see app/Actions/Cases/CreateCase.php:17
* @route '/cases'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Actions\Cases\CreateCase::__invoke
* @see app/Actions/Cases/CreateCase.php:17
* @route '/cases'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Actions\Cases\UpdateCase::__invoke
* @see app/Actions/Cases/UpdateCase.php:17
* @route '/cases/{case}'
*/
export const update = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/cases/{case}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Actions\Cases\UpdateCase::__invoke
* @see app/Actions/Cases/UpdateCase.php:17
* @route '/cases/{case}'
*/
update.url = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { case: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: typeof args.case === 'object'
        ? args.case.id
        : args.case,
    }

    return update.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Cases\UpdateCase::__invoke
* @see app/Actions/Cases/UpdateCase.php:17
* @route '/cases/{case}'
*/
update.patch = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Actions\Cases\SubmitCaseForReview::__invoke
* @see app/Actions/Cases/SubmitCaseForReview.php:17
* @route '/cases/{case}/submit'
*/
export const submit = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

submit.definition = {
    methods: ["post"],
    url: '/cases/{case}/submit',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Actions\Cases\SubmitCaseForReview::__invoke
* @see app/Actions/Cases/SubmitCaseForReview.php:17
* @route '/cases/{case}/submit'
*/
submit.url = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { case: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: typeof args.case === 'object'
        ? args.case.id
        : args.case,
    }

    return submit.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Cases\SubmitCaseForReview::__invoke
* @see app/Actions/Cases/SubmitCaseForReview.php:17
* @route '/cases/{case}/submit'
*/
submit.post = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Actions\Cases\DeleteCase::__invoke
* @see app/Actions/Cases/DeleteCase.php:17
* @route '/cases/{case}'
*/
export const destroy = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/cases/{case}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Actions\Cases\DeleteCase::__invoke
* @see app/Actions/Cases/DeleteCase.php:17
* @route '/cases/{case}'
*/
destroy.url = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { case: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { case: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            case: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        case: typeof args.case === 'object'
        ? args.case.id
        : args.case,
    }

    return destroy.definition.url
            .replace('{case}', parsedArgs.case.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Cases\DeleteCase::__invoke
* @see app/Actions/Cases/DeleteCase.php:17
* @route '/cases/{case}'
*/
destroy.delete = (args: { case: number | { id: number } } | [caseParam: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see routes/web.php:124
* @route '/{sqid}'
*/
export const short = (args: { sqid: string | number } | [sqid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: short.url(args, options),
    method: 'get',
})

short.definition = {
    methods: ["get","head"],
    url: '/{sqid}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/web.php:124
* @route '/{sqid}'
*/
short.url = (args: { sqid: string | number } | [sqid: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { sqid: args }
    }

    if (Array.isArray(args)) {
        args = {
            sqid: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        sqid: args.sqid,
    }

    return short.definition.url
            .replace('{sqid}', parsedArgs.sqid.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see routes/web.php:124
* @route '/{sqid}'
*/
short.get = (args: { sqid: string | number } | [sqid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: short.url(args, options),
    method: 'get',
})

/**
* @see routes/web.php:124
* @route '/{sqid}'
*/
short.head = (args: { sqid: string | number } | [sqid: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: short.url(args, options),
    method: 'head',
})

const cases = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    ogImage: Object.assign(ogImage, ogImage),
    mine: Object.assign(mine, mine),
    new: Object.assign(newMethod, newMethod),
    edit: Object.assign(edit, edit),
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    submit: Object.assign(submit, submit),
    destroy: Object.assign(destroy, destroy),
    answers: Object.assign(answers, answers),
    short: Object.assign(short, short),
}

export default cases